
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';

export const NoAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router)

  const tokenLogIn = sessionStorage.getItem('tokenLogIn');
  // const restrictedRoutes = ['/help', '/contact','/accessibility','/web-conditions','/sitemap','/page-index','/privacy-policy','/general-conditions'];
  
  // if (tokenLogIn == null || restrictedRoutes.includes(state.url)) {
  if (tokenLogIn == null) {
    return true;
  }else{
    router.navigate(['/auth-home']);
    return false
  }
};